import { useEffect, useState } from 'react';

const VISITOR_KEY = 'visitor-counted';
const EXPIRATION_HOURS = 5/60;

export default function VisitorCounter() {
  const [count, setCount] = useState<number | null>(null);
  useEffect(() => {
    const record = localStorage.getItem(VISITOR_KEY);
    const now = Date.now();

    let shouldIncrement = true;

    if (record) {
      const parsed = JSON.parse(record);
      if (now - parsed.timestamp < EXPIRATION_HOURS * 60 * 60 * 1000) {
        shouldIncrement = false;
      }
    }

    const fetchCount = async () => {
      const response = await fetch(`/api/visitor${shouldIncrement ? '' : '?readonly=true'}`);
      const data = await response.json();
      setCount(data.count);

      if (shouldIncrement) {
        localStorage.setItem(VISITOR_KEY, JSON.stringify({ timestamp: now }));
      }
    };

    fetchCount();
  }, []);

  return <p className="text-xs text-gray-500"><i className="iconoir-eye-empty" style={{marginRight: '4px'}} /> Visitors: {count ?? 'Loading...'}</p>;
}
